import React from 'react'
import classnames from 'classnames'

type HorizontalSpinnerProps = {
  size?: 'small' | 'large'
  text?: string | null
  speed?: 'normal' | 'fast'
}

const HorizontalSpinner: React.FC<HorizontalSpinnerProps> = ({ size = 'small', text = null, speed = 'normal' }) => {
  const getTextContent = () => {
    if (text) {
      return <span className="horizontal-spinner__text">{text}</span>
    }
    return null
  }

  const classNames = classnames(
    'horizontal-spinner',
    { 'horizontal-spinner--large': size === 'large' },
    { 'horizontal-spinner--fast': speed === 'fast' }
  )

  return (
    <span className={classNames} role="status" aria-live="polite">
      {getTextContent()}
      <span className="horizontal-spinner__item pulse1"></span>
      <span className="horizontal-spinner__item pulse2"></span>
      <span className="horizontal-spinner__item pulse3"></span>
    </span>
  )
}

export default HorizontalSpinner
